export default {
  // 工具栏
  autoMap: 'Auto-Mapping',
  stopMap: 'Stop Mapping',
  syncMap: 'Sync Map',
  query: 'Search',
  reset: 'Reset',
  tableView: 'Table',
  cardView: 'Card',
  inputDeviceSn: 'Please enter device SN',
  inputMapName: 'Please enter map name',

  // 表格列
  mapName: 'Map Name',
  deviceSn: 'Device SN',
  createTime: 'Create Time',
  action: 'Action',
  mapFile: 'Map File',
  previewImage: 'Preview Image',

  // 通用
  details: 'Details',
  delete: 'Delete',
  more: 'More',
  loading: 'Loading...',
  noData: 'No map data',

  // 自动建图/停止建图模态框
  startAutoMapTitle: 'Auto-Mapping',
  stopAutoMapTitle: 'Stop Mapping',
  startAutoMapBtn: 'Start Mapping',
  stopAutoMapBtn: 'Stop Mapping',
  selectDevice: 'Select Robot Dog',
  online: 'Online',
  offline: 'Offline',
  unnamedDevice: 'Unnamed Device',
  noDevice: 'No robot dog available',

  // 同步地图模态框
  syncMapTitle: 'Sync Map',
  selectMap: 'Select Map',
  selectAllMaps: 'Select maps ({count}/{total})',
  noSyncMap: 'No maps available for sync',
  stepTip: 'Click steps to quickly switch',

  // 确认对话框
  confirmDeleteTitle: 'Confirm delete map "{name}"?',
  confirmDeleteContent: 'This action cannot be undone.',
  confirmDelete: 'Confirm Delete',
  cancel: 'Cancel',

  // 提示信息
  offlineDeviceWarning: 'Offline robot dog cannot be selected',
  pleaseSelectOnlineDevice: 'Please select an online robot dog',
  pleaseSelectMap: 'Please select maps to sync',
  autoMapCommandSent: 'Auto mapping command sent',
  autoMapFailed: 'Auto mapping failed',
  stopMapCommandSent: 'Stop mapping command sent',
  stopMapFailed: 'Stop mapping failed',
  syncMapCommandSent: 'Map sync command sent',
  syncMapFailed: 'Map sync failed',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  mapListFetchFailed: 'Failed to fetch map list',
  missingMapId: 'Missing map ID, cannot view details',
  routeNotFound: 'Map detail route not found. Please configure path=/map_detail in menu (same as /live_stream, robot_dog sub-route, absolute path)',
}